import React from "react";
import cx from "classnames";

interface IQuoteTableFullCardRatingsProps {
    title: string;
    onClickLearnMore: () => void;
    className?: string;
    children: React.ReactNode;
}

const QuoteTableFullCardRatings: React.FC<IQuoteTableFullCardRatingsProps> = (props) => {
    const { title, onClickLearnMore, className, children } = props;

    return (
        <div
            className={cx("layout-flex-row--justify-spaced", {
                [className]: !!className
            })}>
            <div className="layout-flex-column">
                <h4
                    className={cx(
                        "title-quote-card",
                        "text-zero-margin",
                        "text-primary"
                    )}>
                    {title}
                </h4>
                <a onClick={onClickLearnMore}>Learn More</a>
            </div>
            <div className="layout-flex-column--centered">{children}</div>
        </div>
    );
};

export default React.memo(QuoteTableFullCardRatings);
